import { render, staticRenderFns } from "./_filter_list_for_root.vue?vue&type=template&id=80e1a868&scoped=true&"
import script from "./_filter_list_for_root.vue?vue&type=script&lang=js&"
export * from "./_filter_list_for_root.vue?vue&type=script&lang=js&"
import style0 from "./_filter_list_for_root.vue?vue&type=style&index=0&id=80e1a868&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e1a868",
  null
  
)

export default component.exports